/**
 * Универсальный шаринг с поддержкой Telegram, VK, Web.
 *
 * В VK Mini App мы НЕ используем VKWebAppShare и не открываем диалог
 * «опубликовать на стене» — по правилам VK механика постинга на стену
 * в Mini Apps запрещена (https://dev.vk.com/games/promotions/game-mechanics/post).
 * Вместо этого копируем ссылку в буфер и показываем тост — юзер сам решит
 * куда её вставить.
 */
import { detectPlatform } from '../platform/detect';
import bridge from '@vkontakte/vk-bridge';

interface ShareOptions {
  text: string;
  url: string;
}

function showToast(message: string) {
  window.dispatchEvent(new CustomEvent('app-toast', { detail: { message } }));
}

export async function shareResult({ text, url }: ShareOptions) {
  const platform = detectPlatform();

  if (platform === 'telegram') {
    const tg = (window as any).Telegram?.WebApp;
    const shareUrl = 'https://t.me/share/url?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text);
    if (tg?.openTelegramLink) {
      tg.openTelegramLink(shareUrl);
    } else {
      window.open(shareUrl, '_blank');
    }
    return;
  }

  if (platform === 'vk') {
    // В VK — только копирование ссылки, без диалога постинга на стену.
    let copied = false;
    try {
      await bridge.send('VKWebAppCopyText', { text: url });
      copied = true;
    } catch {
      copied = copyToClipboard(url);
    }
    showToast(copied ? 'Ссылка скопирована' : url);
    return;
  }

  // Web / embed — native share или clipboard
  if (navigator.share) {
    navigator.share({ text, url }).catch(() => {
      copyToClipboard(url);
    });
    return;
  }

  copyToClipboard(url);
}

function copyToClipboard(text: string): boolean {
  try {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      return true;
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
